module.exports = __webpack_public_path__ + "static/media/Kellie_Chambers.2a064a52.webp";